import monads from 'browser-monads';
import { navigate } from 'gatsby';
import { useWin } from 'library';

// Use in callbacks and generic functions
// as browserWindow.location.pathname
export const browserWindow = monads.window;

// For use in the component render function
// const browserWindow = useBrowserWindow()
// browserWindow.location.href
export const useBrowserWindow = (effect, deps) => {
  const win = useWin(effect, deps);
  return win || monads.window;
};

export const browserRedirect = (loc) => {
  if (typeof window !== 'undefined') {
    navigate(loc);
  }
};

// as browserDocument.referrer
export const browserDocument = monads.document;
